export default __webpack_public_path__ + "static/media/tilemiddle.ed1f5dd9.jpg";